import { createReducer, on } from '@ngrx/store';
import { LoadStatesProperties, LoadStatesProps } from './states.actions';
import { CountryState } from '@core/models/country-list-response';

export interface StatesState {
  statesProperties: CountryState[];
}

export const initialStatesState: StatesState = {
  statesProperties: [],
};

export const statesReducer = createReducer(
  initialStatesState,

  on(LoadStatesProps, (state) => {
    return {
      ...state,
    };
  }),

  on(LoadStatesProperties, (state, { statesProperties }) => {
    return {
      ...state,
      statesProperties,
    };
  })
);
